import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { IntroScene } from './components/IntroScene';
import { Nav } from './components/Nav';
import { SpaLobby } from './components/SpaLobby';
import { Philosophy } from './components/Philosophy';
import { Amenities } from './components/Amenities';
import { Quote } from './components/Quote';
import { Visit } from './components/Visit';
import { Footer } from './components/Footer';
export function App() {
  const [entered, setEntered] = useState(false);
  return <div className="bg-cream-50 text-ink min-h-screen w-full overflow-x-hidden" data-id="element-0">
      {!entered && <IntroScene onEnter={() => setEntered(true)} data-id="element-1" />}

      {entered && <motion.div initial={{
      opacity: 0,
      scale: 1.06
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.6,
      ease: 'easeOut'
    }} data-id="element-2">
          <Nav data-id="element-3" />
          <main data-id="element-4">
            <SpaLobby data-id="element-5" />
            <Philosophy data-id="element-6" />
            <section className="bg-aubergine-900 py-20 px-6 flex items-center justify-center" data-id="element-7">
              <img src="https://cdn.magicpatterns.com/uploads/esa67RfhCDh55QQfzKbXnN/8812626363569736375[1].png" alt="Wonder of Life Wellness Spa - Marcella Taylor - Marietta, GA" className="w-full max-w-2xl h-auto shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-8" />
            </section>
          </main>
        </motion.div>}
    </div>;
}